// v2.19.38b — Mini-carte 280×180 pour MonComptePage section "Mon adresse".
// Pin or au centre, style dark-v11 non interactif.

import { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

export default function MiniAddressMap({ lat, lng, label }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !TOKEN || lat == null || lng == null) return;
    mapboxgl.accessToken = TOKEN;
    const map = new mapboxgl.Map({
      container: containerRef.current,
      style: "mapbox://styles/mapbox/dark-v11",
      center: [lng, lat],
      zoom: 14,
      interactive: false,
      attributionControl: false,
    });
    mapRef.current = map;

    map.on("load", () => {
      // Pin gold pulse — element HTML custom au lieu de symbol Mapbox (plus simple)
      const el = document.createElement("div");
      el.style.cssText = `
        width: 22px; height: 22px; border-radius: 50%;
        background: radial-gradient(circle, #FFE066 0%, #D4AF37 60%, transparent 75%);
        box-shadow: 0 0 16px rgba(212,175,55,0.7);
        border: 2px solid #FFD700;
      `;
      new mapboxgl.Marker(el).setLngLat([lng, lat]).addTo(map);
    });

    return () => map.remove();
  }, [lat, lng]);

  if (lat == null || lng == null) {
    return (
      <div style={{
        width: "100%", maxWidth: 320, height: 180, borderRadius: 12,
        background: "rgba(255,255,255,0.04)", border: "1px dashed rgba(255,255,255,0.12)",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "rgba(244,241,232,0.4)", fontSize: 11, fontStyle: "italic",
      }}>
        Pas de coordonnées pour cette adresse
      </div>
    );
  }

  return (
    <div data-testid="mini-address-map" style={{
      position: "relative", width: "100%", maxWidth: 320, height: 180,
      borderRadius: 12, overflow: "hidden",
      border: "1px solid rgba(212,175,55,0.25)",
      boxShadow: "0 4px 14px rgba(0,0,0,0.35)",
    }}>
      <div ref={containerRef} style={{ width: "100%", height: "100%" }} />
      {label && (
        <div style={{
          position: "absolute", bottom: 8, left: 8, right: 8,
          background: "rgba(15,26,46,0.85)", color: "#D4AF37",
          padding: "5px 10px", borderRadius: 8, fontSize: 11, fontWeight: 700,
          textAlign: "center", letterSpacing: 0.3,
          border: "1px solid rgba(212,175,55,0.3)",
        }}>
          📍 {label}
        </div>
      )}
    </div>
  );
}
